import { render } from "./TeamEdit.vue?vue&type=template&id=061e5c9a"
import script from "./TeamEdit.vue?vue&type=script&lang=js"
export * from "./TeamEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__